import React from "react";
import ServiceLogsFiltersContainer from "./ServiceLogsFiltersContainer";
import PropTypes from "prop-types";

const ServiceLogsContainer = ({ documentId }) => {
  return <ServiceLogsFiltersContainer documentId={documentId} />;
};

ServiceLogsContainer.propTypes = {
  documentId: PropTypes.number.isRequired
};

export default ServiceLogsContainer;
